import React from 'react';
import { CTAButton } from '../CTAButton';
export function FiveReasons() {
  return <div className="space-y-8" data-id="element-106">
      <div className="text-center space-y-4" data-id="element-107">
        <h2 className="text-3xl font-bold text-gray-900" data-id="element-108">
          5 Reasons Women Over 50 Are Obsessed With This Micro-Infusion Device
        </h2>
      </div>
      {/* Reason 1 */}
      <div className="space-y-4" data-id="element-109">
        <h3 className="text-2xl font-bold text-pink-600" data-id="element-110">
          #1 - It Reaches the Deep Skin Layers Where Aging Actually Happens
        </h3>
        <div className="w-full aspect-video bg-gray-200 rounded-lg flex items-center justify-center" data-id="element-111">
          <img src="https://cdn.shopify.com/s/files/1/0619/1693/8405/files/5a_GIF_of_penetration_of_CBF_into_skin_with_Serum.gif?v=1762445500" alt="Three-step usage guide" className="w-full h-full object-cover rounded-lg" data-id="element-112" />
        </div>
        <p className="text-lg text-gray-800 leading-relaxed" data-id="element-113">
          Unlike creams and serums that sit on your skin's surface, this device
          delivers active ingredients directly to the dermis—the deeper layer
          where collagen is produced, where elasticity lives, where real
          anti-aging happens.
        </p>
        <p className="text-lg text-gray-800 leading-relaxed" data-id="element-114">
          Your epidermis (outer layer) is mostly dead skin cells. Putting
          anti-aging ingredients there is like trying to strengthen a building
          by painting its exterior walls.
        </p>
        <p className="text-lg text-gray-800 leading-relaxed" data-id="element-115">
          But the dermis? That's where your skin's support structure exists.
          That's where wrinkles form. That's where sagging begins.
        </p>
        <p className="text-lg text-gray-800 leading-relaxed" data-id="element-116">
          This device creates hundreds of micro-channels that bypass the
          Permeability Wall and deliver ingredients straight to that deeper
          layer.
        </p>
        <p className="text-lg text-gray-800 leading-relaxed" data-id="element-117">
          For the first time in years, active ingredients can actually reach the
          place where they need to work.
        </p>
        <div className="bg-green-50 border-2 border-green-500 rounded-lg p-6 text-center" data-id="element-118">
          <p className="text-xl font-bold text-green-800" data-id="element-119">
            Opens 600+ Direct-Access Gateways in a single treatment to reach the
            dermal layer
          </p>
        </div>
      </div>
      {/* Reason 2 */}
      <div className="space-y-4" data-id="element-120">
        <h3 className="text-2xl font-bold text-pink-600" data-id="element-121">
          #2 - The Results Are Clinical-Grade
        </h3>
        <div className="w-full aspect-video bg-gray-200 rounded-lg flex items-center justify-center" data-id="element-122">
          <img src="https://cdn.shopify.com/s/files/1/0619/1693/8405/files/5b.png?v=1762311268" alt="Three-step usage guide" className="w-full h-full object-cover rounded-lg" data-id="element-123" />
        </div>
        <p className="text-lg text-gray-800 leading-relaxed" data-id="element-124">
          This isn't just "nice" skincare. These are medical-grade results
          backed by real science:
        </p>
        <ul className="list-disc list-inside space-y-2 pl-4" data-id="element-125">
          <li className="text-lg text-gray-800 leading-relaxed" data-id="element-126">
            48.9% reduction in wrinkle depth (clinically measured)
          </li>
          <li className="text-lg text-gray-800 leading-relaxed" data-id="element-127">
            400% increase in collagen production over 4 weeks
          </li>
          <li className="text-lg text-gray-800 leading-relaxed" data-id="element-128">
            60% improvement in skin elasticity
          </li>
        </ul>

        <p className="text-lg text-gray-800 leading-relaxed" data-id="element-129">
          The device delivers a peptide blend that works similarly to Botox but
          without injections—it relaxes facial muscles to smooth expression
          lines.
        </p>
        <p className="text-lg text-gray-800 leading-relaxed" data-id="element-130">
          It also contains a powerful peptide complex that signals your skin
          cells to rebuild six different structural proteins that break down
          with age—essentially telling your skin to act younger again.
        </p>
        <p className="text-lg text-gray-800 leading-relaxed" data-id="element-131">
          And the multi-weight hyaluronic acid system? It hydrates at three
          different depths: the surface for immediate plumpness, the middle
          layer for lasting moisture, and the deep layer to support collagen
          structure.
        </p>
        <p className="text-lg text-gray-800 leading-relaxed" data-id="element-132">
          These are the same ingredients and mechanisms you'd get from a
          dermatologist—for a fraction of the cost.
        </p>
      </div>
      {/* Reason 3 */}
      <div className="space-y-4" data-id="element-133">
        <h3 className="text-2xl font-bold text-pink-600" data-id="element-134">
          #3 - It Works Fast (Like, Really Fast)
        </h3>
        <div className="w-full aspect-video bg-gray-200 rounded-lg flex items-center justify-center" data-id="element-135">
          <img src="https://cdn.shopify.com/s/files/1/0619/1693/8405/files/5c.png?v=1762311265" alt="Three-step usage guide" className="w-full h-full object-cover rounded-lg" data-id="element-136" />
        </div>
        <p className="text-lg text-gray-800 leading-relaxed font-semibold" data-id="element-137">
          I saw results in one hour. Not weeks. Not months. One hour.
        </p>
        <p className="text-lg text-gray-800 leading-relaxed" data-id="element-138">
          After my first treatment:
        </p>
        <ul className="list-disc list-inside space-y-2 pl-4" data-id="element-139">
          <li className="text-lg text-gray-800 leading-relaxed" data-id="element-140">
            My fine lines looked softer
          </li>
          <li className="text-lg text-gray-800 leading-relaxed" data-id="element-141">
            My skin felt plumper and firmer
          </li>
          <li className="text-lg text-gray-800 leading-relaxed" data-id="element-142">
            That tired, dull look was replaced with a healthy glow
          </li>
          <li className="text-lg text-gray-800 leading-relaxed" data-id="element-143">
            Even my husband noticed (and he never notices anything!)
          </li>
        </ul>
        <p className="text-lg text-gray-800 leading-relaxed" data-id="element-144">
          By week 2, my deeper wrinkles had visibly reduced.
        </p>
        <p className="text-lg text-gray-800 leading-relaxed" data-id="element-145">
          By week 4, people started asking what I'd done differently.
        </p>
      </div>
      {/* Reason 4 */}
      <div className="space-y-4" data-id="element-146">
        <h3 className="text-2xl font-bold text-pink-600" data-id="element-147">
          #4 - It's Incredibly Simple to Use
        </h3>
        <div className="w-full aspect-video bg-gray-200 rounded-lg flex items-center justify-center" data-id="element-148">
          <img src="https://cdn.shopify.com/s/files/1/0619/1693/8405/files/5d.png?v=1762311265" alt="Three-step usage guide" className="w-full h-full object-cover rounded-lg" data-id="element-149" />
        </div>
        <p className="text-lg text-gray-800 leading-relaxed font-semibold" data-id="element-150">
          5 minutes. Once a month. That's it.
        </p>
        <div className="grid md:grid-cols-3 gap-6" data-id="element-151">
          <div className="text-center space-y-2" data-id="element-152">
            <div className="w-16 h-16 bg-pink-500 text-white rounded-full flex items-center justify-center text-2xl font-bold mx-auto" data-id="element-153">
              1
            </div>
            <h4 className="font-bold text-gray-900" data-id="element-154">Cleanse your face</h4>
          </div>
          <div className="text-center space-y-2" data-id="element-155">
            <div className="w-16 h-16 bg-pink-500 text-white rounded-full flex items-center justify-center text-2xl font-bold mx-auto" data-id="element-156">
              2
            </div>
            <h4 className="font-bold text-gray-900" data-id="element-157">
              Apply the serum cartridge and stamp
            </h4>
          </div>
          <div className="text-center space-y-2" data-id="element-158">
            <div className="w-16 h-16 bg-pink-500 text-white rounded-full flex items-center justify-center text-2xl font-bold mx-auto" data-id="element-159">
              3
            </div>
            <h4 className="font-bold text-gray-900" data-id="element-160">
              See results in under an hour
            </h4>
          </div>
        </div>
        <p className="text-lg text-gray-800 leading-relaxed" data-id="element-161">
          No complicated technique to learn. No painful process. Just gentle,
          effective treatment.
        </p>
        <p className="text-lg text-gray-800 leading-relaxed" data-id="element-162">
          I use it while watching TV. It's become my favorite self-care
          ritual—one that actually delivers results.
        </p>
      </div>
      {/* Reason 5 */}
      <div className="space-y-4" data-id="element-163">
        <h3 className="text-2xl font-bold text-pink-600" data-id="element-164">
          #5 - You Can Try It Completely Risk-Free
        </h3>
        <div className="w-full aspect-video bg-gray-200 rounded-lg flex items-center justify-center" data-id="element-165">
          <img src="https://cdn.shopify.com/s/files/1/0619/1693/8405/files/5e.png?v=1762311261" alt="Three-step usage guide" className="w-full h-full object-cover rounded-lg" data-id="element-166" />
        </div>
        <p className="text-lg text-gray-800 leading-relaxed" data-id="element-167">
          Here's what really convinced me to try it:
        </p>
        <p className="text-lg text-gray-800 leading-relaxed font-semibold" data-id="element-168">
          30-day money-back guarantee. Use the entire device. See the results
          for yourself. If you're not thrilled, return it for a full refund.
        </p>
        <p className="text-lg text-gray-800 leading-relaxed" data-id="element-169">
          No complicated returns process. No restocking fees. Just results or
          your money back.
        </p>
        <p className="text-lg text-gray-800 leading-relaxed" data-id="element-170">
          Plus, right now they're offering 64% off for first-time customers,
          which makes it more affordable than even a single dermatologist visit.
        </p>
      </div>
    </div>;
}